import { AnyAction } from '@reduxjs/toolkit';
import * as entityHandlers from '../../../modules/bin/entityHandlers';
import { GridOptions } from '../../../components/common/grid/gridOptions';
import ColumnModel from '../../../components/common/grid/columnModel';
import { Record } from '../../../modules/bin/utility';
import { CLEAR } from '../../../modules/general';
import update from '../../../helpers/update';
import { List as ListConstants } from '../../../constants';
import {
  campaignOrganizerColumnData,
  campaignOrganizerDefaultOrderBy,
  campaignOrganizersAvailableFiltersKeys,
} from '../../../constants/campaignOrganizer';
import {
  CAMPAIGN_ORGANIZERS_METADATA_REQUESTED,
  CAMPAIGN_ORGANIZERS_METADATA_SUCCESS,
  CAMPAIGN_ORGANIZERS_METADATA_FAILURE,
  CAMPAIGN_ORGANIZERS_LIST_DATA_REQUESTED,
  CAMPAIGN_ORGANIZERS_LIST_DATA_SUCCESS,
  CAMPAIGN_ORGANIZERS_LIST_DATA_FAILURE,
  CAMPAIGN_ORGANIZERS_CREATE_REQUESTED,
  CAMPAIGN_ORGANIZERS_CREATE_SUCCESS,
  CAMPAIGN_ORGANIZERS_CREATE_FAILURE,
  CAMPAIGN_ORGANIZERS_UPDATE_REQUESTED,
  CAMPAIGN_ORGANIZERS_UPDATE_SUCCESS,
  CAMPAIGN_ORGANIZERS_UPDATE_FAILURE,
  CAMPAIGN_ORGANIZERS_GET_REQUESTED,
  CAMPAIGN_ORGANIZERS_GET_SUCCESS,
  CAMPAIGN_ORGANIZERS_GET_FAILURE,
  CAMPAIGN_ORGANIZERS_DELETE_REQUESTED,
  CAMPAIGN_ORGANIZERS_DELETE_SUCCESS,
  CAMPAIGN_ORGANIZERS_DELETE_FAILURE,
  CAMPAIGN_ORGANIZERS_MESSAGE_CLEAR,
} from './campaignOrganizerTypes';

const initialState = {
  timestamp: new Date().getTime(),
  campaignOrganizersList: new GridOptions()
    .addColumns(
      campaignOrganizerColumnData.map((x) =>
        new ColumnModel(x.path, x.header, x.customFormatter).setVisible(x.defaultVisible)
      )
    )
    .orderBy(campaignOrganizerDefaultOrderBy.path, campaignOrganizerDefaultOrderBy.order)
    .addAvailableFiltersKeys(campaignOrganizersAvailableFiltersKeys)
    .getState(),
  record: Record.getDefaultState(),
  recordCreate: Record.getDefaultState(),
  recordEdit: Record.getDefaultState(),
  recordDelete: Record.getDefaultState(),
};

const campaignOrganizerReducer = (state = initialState, action: AnyAction) => {
  let newState = state;
  switch (action.type) {
    case CLEAR:
      newState = initialState;
      break;

    case CAMPAIGN_ORGANIZERS_METADATA_REQUESTED:
      newState = entityHandlers.metadataRequestedHandler(state, action);
      break;
    case CAMPAIGN_ORGANIZERS_METADATA_SUCCESS:
      newState = entityHandlers.metadataSuccessHandler(state, action);
      break;
    case CAMPAIGN_ORGANIZERS_LIST_DATA_REQUESTED:
      newState = entityHandlers.listDataRequestedHandler(state, action);
      break;
    case CAMPAIGN_ORGANIZERS_LIST_DATA_SUCCESS:
      newState = entityHandlers.listDataSuccessHandler(state, action);
      break;
    case CAMPAIGN_ORGANIZERS_LIST_DATA_FAILURE:
      newState = entityHandlers.listDataFailureHandler(state, action);
      break;
    case CAMPAIGN_ORGANIZERS_MESSAGE_CLEAR:
      newState = entityHandlers.crudClearErrorHandler(state, action.payload.key);
      break;
    case CAMPAIGN_ORGANIZERS_METADATA_FAILURE:
      newState = entityHandlers.listMetadataFailureHandler(state, action);
      break;
    case CAMPAIGN_ORGANIZERS_CREATE_REQUESTED:
    case CAMPAIGN_ORGANIZERS_UPDATE_REQUESTED:
    case CAMPAIGN_ORGANIZERS_GET_REQUESTED:
    case CAMPAIGN_ORGANIZERS_DELETE_REQUESTED:
      newState = entityHandlers.getRecordRequestedHandler(state, action);
      break;
    case CAMPAIGN_ORGANIZERS_CREATE_SUCCESS:
    case CAMPAIGN_ORGANIZERS_UPDATE_SUCCESS:
    case CAMPAIGN_ORGANIZERS_DELETE_SUCCESS:
      newState = entityHandlers.getRecordSuccessHandler(state, action);
      newState = update.set(newState, 'campaignOrganizersList.ready', ListConstants.LIST_STATUS_NO_DATA);
      break;
    case CAMPAIGN_ORGANIZERS_GET_SUCCESS:
      newState = entityHandlers.getRecordSuccessHandler(state, action);
      break;
    case CAMPAIGN_ORGANIZERS_CREATE_FAILURE:
    case CAMPAIGN_ORGANIZERS_UPDATE_FAILURE:
    case CAMPAIGN_ORGANIZERS_GET_FAILURE:
    case CAMPAIGN_ORGANIZERS_DELETE_FAILURE:
      newState = entityHandlers.crudErrorHandler(state, action);
      break;
    default:
      break;
  }
  return newState;
};

export default campaignOrganizerReducer;
